import React from 'react';
import { Box, Typography, Button } from '@mui/material';

/**
 * Empty-state container. Replaces ad-hoc "No data" Typography blocks.
 *
 * Props:
 *   icon        — React component (typically a MUI icon), rendered at 48px
 *   title       — short headline
 *   description — explanatory line under the title
 *   action      — { label, onClick, icon?, variant? } — optional CTA button
 *   compact     — tighter vertical padding (for table-cell or drawer use)
 */
export function EmptyState({ icon: Icon, title, description, action, compact = false, sx }) {
  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', textAlign: 'center',
      py: compact ? 3 : 6, px: 3,
      ...sx,
    }}>
      {Icon && <Icon sx={{ fontSize: compact ? 32 : 48, color: 'text.disabled', mb: 1.5 }} />}
      {title && (
        <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight={600} sx={{ mb: 0.5, color: 'text.primary' }}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360, mb: action ? 2 : 0 }}>
          {description}
        </Typography>
      )}
      {action && (
        <Button
          variant={action.variant || 'contained'}
          onClick={action.onClick}
          startIcon={action.icon}
          size={compact ? 'small' : 'medium'}
        >
          {action.label}
        </Button>
      )}
    </Box>
  );
}

export default EmptyState;
